import { render, staticRenderFns } from "./NewListItemLoadingSkeleton.vue?vue&type=template&id=212266bf"
import script from "./NewListItemLoadingSkeleton.vue?vue&type=script&lang=ts"
export * from "./NewListItemLoadingSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports